import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const EntryPage = () => {
  const [modelLink, setModelLink] = useState("");
  const navigate = useNavigate();

  const handleLoadModel = () => {
    if (modelLink.trim()) {
      navigate("/app", { state: { modelLink } });
    } else {
      alert("Please enter a valid URL!");
    }
  };

  return (
    <div className="bg-black text-white min-h-screen p-6">
      {/* Header Section */}
      <div className="flex flex-row items-center mb-4">
        <img
          src="/logo.png" // Ensure this is your logo file in the public folder
          alt="Logo"
          className="h-12 mr-4"
        />
        <h2 className="text-xl font-bold">SmilingRobo Platform</h2>
      </div>

      {/* White line below the header */}
      <div className="border-b-2 border-gray-900 mb-10"></div>

      {/* Main Content Section */}
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-4">Use your Robot</h1>
        <input
          type="text"
          placeholder="Enter GLTF/GLB model URL"
          value={modelLink}
          onChange={(e) => setModelLink(e.target.value)}
          className="w-full sm:w-4/5 max-w-md p-2 mb-4 rounded border border-gray-300 text-black"
        />
        
        <button
          onClick={handleLoadModel}
          className="bg-gray-950 hover:bg-gray-700 text-white font-bold py-2 px-6 rounded m-4"
        >
          Load Model
        </button>

        <p className="text-sm text-gray-400 mt-4">
  Please note: The uploaded robot model will be used to create an environment
  for training purposes.
</p>

      </div>
    </div>
  );
};

export default EntryPage;
